import React from 'react';
import NewarkDonorList from './NewarkDonorList';

export default props => {
  return (
    <div className="newark__container">
      <div className="newark__header">
        <div className="newark__heading-1-container">
          <h1 className="newark__heading-1">{props.title}</h1>
        </div>
        <div className="newark__subheading-container">
          <p className="newark__subheading">{props.subtitle}</p>
        </div>
      </div>

      <ul className="newark__donor-lists-container">
        {
          props.donorLists.map((donorList, i) => {
            return <NewarkDonorList donors={donorList.donors} listHeading={donorList.name} key={'donor-list-' + i}/>
          })
        }
      </ul>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/NewarkDonorLists.js